import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const CURRENCY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Currency.Name')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Currency.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.Currency.SapCode')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const CURRENCY_CONFIG = {
  entityName: 'Currency',
  localizationKey: 'Controlling::Entity.Currency',
  fields: CURRENCY_FIELDS,
  permission: 'ControllingContract.Currencies',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
